<script>
import { Line, mixins } from 'vue-chartjs'
import 'chartjs-plugin-datalabels'
import 'chartjs-plugin-colorschemes'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
      /*{
        legend: {
          fullWidth: true,
          maxWidth: 200,
        },
        tooltips: {
        bodyFontSize: 15,
        enabled: true,
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function(tooltipItems, data) { 
            return data.datasets[tooltipItems.datasetIndex].label + ": R$ "+ Number(tooltipItems.yLabel).toFixed(2);
          },
        }
      },
      plugins: {
        datalabels: {
          display: false,
        }
      }

      })//*/
  }
}
</script>

<style>
</style>
